import React, { Component } from 'react';
import { insertDataBlock } from 'megadraft';
import VideoIcon from "megadraft/lib/icons/video";

export default class BlockButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    const src = window.prompt('Enter the YouTube embed URL');
    if (!src) return;
    const data = { type: 'youtube-video', src };
    // Calls the onChange method with the new state.
    this.props.onChange(insertDataBlock(this.props.editorState, data));
  }

  render() {
    return (
      <button className={this.props.className} onClick={this.onClick}>
         <VideoIcon className="sidemenu__button__icon" />
      </button>
    );
  }
}
